/*
各種ソーシャルサービスボタンを簡単設置

2017/03/15 ver.2.1.0
    - ES2015形式に変更
2016/11/24 ver.2.0.0
    - Webpack対応
*/

export default function (target) {

    const window_opt = 'width=550,height=450,personalbar=0,' +
        'toolbar=0,scrollbars=1,resizable=1';
    const e = encodeURIComponent;

    /**
     * クリック動作
     * @this clickエレメント
     * @return ボタンの動作を無視
     */
    $(document).on('click', target, function () {
        const $this = $(this);
        const via = $this.data('ccl-share-via');
        const flw = $this.data('ccl-share-flw');
        let url = $this.data('ccl-share-url');
        let msg = $this.data('ccl-share-msg');

        if (!url) url = location.href;
        if (!msg) msg = document.title;

        switch ($this.data('ccl-share-svc')) {
        case 'twitter':
            twitter(url, msg, via, flw);
            break;
        case 'facebook':
            facebook(url);
            break;
        case 'line':
            line(url, msg);
            break;
        case 'feedly':
            feedly(url);
            break;
        case 'pocket':
            pocket(url);
            break;
        case 'hatebu':
            hatebu(url, msg);
            break;
        case 'google':
            google(url);
            break;
        default:
        }

        return false;
    });

    /**
    * Twitter
    */
    function twitter(url, msg, via, follow) {
        let openURL = `http://twitter.com/share?url=${e(url)}&text=${e(msg)}+`;
        if (via) openURL += `&via=${e(via)}`;
        if (follow) openURL += `&related=${e(follow)}`;
        window.open(openURL, 'tweetwindow', window_opt);
    }

    /**
    * Facebook
    */
    function facebook(url) {
        const openURL = `http://www.facebook.com/share.php?u=${e(url)}`;
        window.open(openURL, 'facebookwindow', window_opt);
    }

    /**
    * LINE
    */
    function line(url, msg) {
        window.location.href = `line://msg/text/${e(msg)} ${e(url)}`;
    }

    /**
    * feedly
    */
    function feedly(url) {
        const openURL = `http://feedly.com/i/subscription/feed/${e(url)}`;
        window.open(openURL, 'feedlywindow', window_opt);
    }

    /**
    * Pocket
    */
    function pocket(url) {
        const openURL = `http://getpocket.com/edit?url=${e(url)}`;
        window.open(openURL, 'feedlywindow', window_opt);
    }

    /**
    * はてなブックマーク
    */
    function hatebu(url, msg) {
        const openURL = `//b.hatena.ne.jp/add?mode=confirm&url=` +
            `${e(url)}&title=${e(msg)}`;
        window.open(openURL, 'hatebuwindow', window_opt);
    }

    /**
    * google plus
    */
    function google(url) {
        const openURL = `https://plus.google.com/share?url=${e(url)}`;
        window.open(openURL, 'googlewindow', window_opt);
    }

}


// WEBPACK FOOTER //
// /Users/dada/www/_caracol_works/javascript/for_webpack/caracol/caracol_es2015.1.0/social/share_button.js